import React, { Component, Fragment } from 'react';
import styles from './ImportForm.module.css';
import Select from 'react-select';
import Checkbox from 'rc-checkbox';

export default class ImportForm extends Component {
  state = {};

  onChange = e => {
    const { onChange } = this.props;
    const key = e.target.id;
    const value = e.target.value;
    onChange(key, value);
  };

  onSelectChange = (prop, data) => {
    const { onChange } = this.props;
    const { key, multi } = prop;
    const values = multi ? data.map(item => item.value) : data && data.value;
    onChange(key, values);
  };

  onCheckBoxChange = (e, key) => {
    const { onChange } = this.props;
    const value = e.target.checked;
    onChange(key, value);
  };

  render() {
    const { schema, formData, tags, catogary } = this.props;
    const { metadata } = formData;
    if (catogary === 'materials') {
      for (let key in metadata) {
        const newKey = 'metadata.' + key.replace(' ', '_');
        formData[newKey] = metadata[key];
      }
    }
    const options = tags ? tags.map(tag => tag[0]) : [];
    return (
      <div className={styles.container}>
        {schema &&
          schema.map((v, idx) => {
            if (v.key === 'reviewers') return;
            return (
              <Fragment key={v.label}>
                <div
                  className={styles.inputLabel}
                  style={{ marginTop: idx === 0 ? '20px' : '30px' }}
                >
                  {v.label}
                  {v.required && (
                    <span className={styles.required}>required</span>
                  )}
                </div>
                {v.select ? (
                  <Select.Creatable
                    className={styles.multiSelect}
                    multi={v.multi ? true : false}
                    onChange={data => this.onSelectChange(v, data)}
                    placeholder={formData[v.key]}
                    value={formData[v.key]}
                    options={v.options || options}
                  />
                ) : v.checkBox ? (
                  <Fragment>
                    <Checkbox
                      style={{ marginLeft: '30px' }}
                      checked={formData[v.key]}
                      onChange={e => this.onCheckBoxChange(e, v.key)}
                    />{' '}
                    &nbsp; Yes
                  </Fragment>
                ) : (
                  <input
                    className={styles.inputField}
                    style={{ width: v.length }}
                    onBlur={this.onChange}
                    defaultValue={formData[v.key]}
                    id={v.key}
                  />
                )}
              </Fragment>
            );
          })}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ImportForm/index.js